module.exports = __webpack_public_path__ + "img/long-island-iced-tea.c9bc0cb2.jpg";